import * as React from 'react'
import { useWalletPayment } from 'hooks'
import CustomPaymentButton from './CustomPaymentButton'
import ExpressCheckoutLoadingSkeleton from './ExpressCheckoutLoadingSkeleton'
import ExpressCheckout from './ExpressCheckout'

const WalletPaymentButton: React.FC<WalletPaymentButtonProps> = ({
  cart,
  currencyCode,
  isPdp = false,
  prepareForPayment,
  teardownFromPayment,
  forceLoading = false
}) => {
  const {
    isAvailable,
    availableMethod,
    errorMsg,
    loading,
    handlePaymentButtonClick,
    paymentRequest
  } = useWalletPayment(
    prepareForPayment,
    teardownFromPayment,
    cart,
    currencyCode
  )
  const resultantLoadingState = loading || forceLoading

  const loadingScreen = isPdp ? (
    // custom payment btn from component library has a loading state
    <CustomPaymentButton
      isPdp={true}
      isAvailable={isAvailable}
      loading={resultantLoadingState}
      availableMethod={availableMethod}
      errorMsg={errorMsg}
      clickHandler={handlePaymentButtonClick}
    />
  ) : (
    <ExpressCheckoutLoadingSkeleton />
  )

  if (resultantLoadingState) {
    return loadingScreen
  }

  if (paymentRequest) {
    return isPdp ? (
      <CustomPaymentButton
        isPdp={true}
        isAvailable={isAvailable}
        loading={resultantLoadingState}
        availableMethod={availableMethod}
        errorMsg={errorMsg}
        clickHandler={handlePaymentButtonClick}
      />
    ) : (
      <ExpressCheckout
        isPdp={false}
        isAvailable={isAvailable}
        loading={resultantLoadingState}
        availableMethod={availableMethod}
        errorMsg={errorMsg}
        clickHandler={handlePaymentButtonClick}
      />
    )
  }

  return null
}

export interface CartItem {
  ProductName: string
  ItemPrice: string
  ItemCurrency: string
}

interface WalletPaymentButtonProps {
  currencyCode: string
  cart: CartItem[]
  isPdp?: boolean
  prepareForPayment?: () => void
  teardownFromPayment?: () => void
  forceLoading?: boolean
}

export default WalletPaymentButton
